import { de, en, es, fr, hi, ko, ru, zh } from "make-plural/plurals";
const productionLocales = {
    en: { plurals: en, time: "en-US", label: "English" },
    fr: { plurals: fr, time: "fr-FR", label: "Français" },
    de: { plurals: de, time: "de-DE", label: "Deutsch" },
    ru: { plurals: ru, time: "ru-RU", label: "Русский" },
    "zh-CN": {
        plurals: zh,
        time: "zh-CN",
        label: "中文",
    },
    es: { plurals: es, time: "es-ES", label: "Español" },
    hi: { plurals: hi, time: "hi-IN", label: "हिन्दी" },
};
const stagingLocales = Object.assign({}, productionLocales, {
    ko: { plurals: ko, time: "ko-KR", label: "한국어" },
    "en-pseudo": {
        plurals: en,
        time: "en-US",
        label: "Pseudo",
    },
});
export const getLocales = (is_production) => {
    return is_production ? productionLocales : stagingLocales;
};
